import { Injectable } from '@angular/core';
import differenceInDays from 'date-fns/differenceInDays';
import {CountdownEvent} from "ngx-countdown";

@Injectable({
  providedIn: 'root'
})
export class CountdownService {

  AUCTION_START = new Date(2024,11,8,19)
  AUCTION_END = new Date(2024,11,11,19)

  auctionStarted: boolean
  auctionEnded: boolean

  constructor() {
    this.auctionStarted = this.isAuctionStarted()
    this.auctionEnded = this.isAuctionEnded()
  }

  startAuction() {
    this.auctionStarted = true
  }

  public countdownToEndFinished() {
    this.auctionEnded = true
  }

  public isAuctionStarted() {
    // return true
    return this.AUCTION_START.getTime() <= new Date().getTime()
  }

  public isAuctionEnded() {
    // return true
    return this.AUCTION_END.getTime() <= new Date().getTime();
  }

  public isAuctionRunning() {
    return this.isAuctionStarted() && !this.isAuctionEnded()
  }

  public getRemainingDaysToStart() {
    return this.getRemainingDaysTo(this.AUCTION_START)
  }

  getRemainingDaysToEnd() {
    return this.getRemainingDaysTo(this.AUCTION_END)
  }

  private getRemainingDaysTo(d: Date) {
    const remainingDays = differenceInDays(d, new Date())
    if (remainingDays < 1) return ""
    if (remainingDays == 1) return '1 den a '
    if (remainingDays > 1 && remainingDays < 5) return `${remainingDays} dny a `
    return `${remainingDays} dní a `
  }

  isTimeToBeSorry() {
    const d = new Date().getDate()
    return this.isAuctionStarted() && !this.isAuctionEnded() && (d === 28 || d === 29)
  }

  handleEvent(event: CountdownEvent) {
    if (event.action === 'done') {
      this.countdownToEndFinished()
    }
  }
}
